import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCartPlus } from "@fortawesome/free-solid-svg-icons"

export const CartPlus = (props) => {
  return <FontAwesomeIcon faIcon={faCartPlus} {...props} />
}
